var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLorealLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 18,
    viewBox: "0 0 100 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8502_351941)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.404 16.789h12.904V15.22H56.616v-5.018h8.03V8.616h-8.03V3.994h10.692V2.43H54.404zM61.11.11l-1.747 1.953L64.847.11zm27.862 15.11V2.432h-2.017V16.79H100v-1.57zM75.67 2.431 68.332 16.79h2.48l1.877-3.716h8.802l1.893 3.716h2.455L78.495 2.43zm-2.052 8.842 3.458-6.858 3.499 6.858zm-26.217-.488c3.307-.878 3.628-3.325 3.611-4.2-.197-2.565-1.934-4.154-5.056-4.154H36.86V16.79h2.074v-6.023h5.922l4.356 6.023h2.614s-3.136-4.054-4.425-6.004M45.673 9.07h-6.74V4.13h6.975c1.606 0 2.509.746 2.834 1.694.216.649.078 1.501-.278 2.082-.583.96-1.69 1.164-2.79 1.164M24.399 0c-5.854 0-9.844 4.106-9.844 9.075 0 5.232 4.407 8.925 9.843 8.925 5.433 0 9.838-3.64 9.838-8.925C34.236 4.105 30.197 0 24.4 0m-.07 16.218c-4.05 0-7.387-3.238-7.387-7.138 0-3.895 3.179-7.287 7.543-7.287 4.256 0 7.385 3.392 7.385 7.287 0 3.9-3.494 7.138-7.542 7.138M9.333 7.51h1.496l2.716-5.079H11.36zm-7.315 7.71V2.432H0V16.79h13.045v-1.57z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8502_351941"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v18H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLorealLogo);
export default __webpack_public_path__ + "static/media/loreal-logo.3930b9170fdda58c7ea5b3431bab4ce2.svg";
export { ForwardRef as ReactComponent };